import { useNavigate } from 'react-router-dom';

import { Layout } from '../components/Layout';
import { PhoneNumberLoginForm } from '../components/PhoneNumberLoginForm';
import { LoginForm } from '../components/LoginForm';

export const Login = () => {
  const navigate = useNavigate();

  return (
    <Layout title="Login to account">
      {/* <PhoneNumberLoginForm onSuccess={() => navigate('/auth/verify-otp')} /> */}
      <LoginForm onSuccess={() => navigate('/app')} />
    </Layout>
  );
};
